import React, { useEffect, useState } from "react";
import LoadingSpinner from "../components/LoadingSpinner";
import axiosInstance from "../utils/axiosInstance";
import { useNavigate } from 'react-router-dom';

const BuyTopupHistroy = () => {
  const [data, setData] = useState([]);
  const [renewData, setRenewData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showRenewData, setShowRenewData] = useState(false);
  const [actionTaken, setActionTaken] = useState(false);
const [selectedOrder, setSelectedOrder] = useState(null);
const [modalVisible, setModalVisible] = useState(false);
const [modalLoading, setModalLoading] = useState(false);

  const apiUrl = process.env.REACT_APP_BASE_URL;
const navigate = useNavigate(); 
  const fetchTopupHistory = async () => {
    const partnerCode = localStorage.getItem("partnerCode");

    try {
      const response = await axiosInstance.get(
        `ESIM/Get_topup_salereport`,
        {
          params: {
            flag: 2,
            partnercode: partnerCode,
          },
        }
      );
      if (response.data.isSuccess) {
        setData(response.data.gettopup_sale);
      }
    } catch (err) {
      console.error("Error fetching top-up data:", err);
    } finally {
      setLoading(false);
    }
  };

  const fetchRenewData = async () => {
    const partnerCode = localStorage.getItem("partnerCode");

    try {
      const response = await axiosInstance.post(
        `Renew/GetRenewData`,
        {
          partnerCode: partnerCode,
          pageSize: 100,
          pageIndex: 1,
        }
      );

      if (response.data?.isSuccess) {
        setRenewData(response.data.renewData);
      } else {
        console.error("API response unsuccessful");
      }
    } catch (error) {
      console.error("Error fetching renew data:", error);
    }

    setLoading(false);
  };

  useEffect(() => {
    if (showRenewData) {
      fetchRenewData();
    } else {
      fetchTopupHistory();
    }
  }, [showRenewData]);

  const handleToggleView = () => {
    setShowRenewData(!showRenewData);
    setLoading(true);
  };

const handleStatusUpdate = async () => {
  setModalLoading(true);

  const payload = {
    orderID: selectedOrder.orderID,
    status: selectedOrder.status === "Recharge" ? "Recharge" : "Recharge",
  };

  alert(`Sending to API:\nOrder ID: ${payload.orderID}\nStatus: ${payload.status}`);

  try {
    const response = await axiosInstance.post(
      `Renew/UpdateRenewStatus`,
      payload
    );

    if (response.data?.isSuccess) {
      setActionTaken((prev) => !prev);
      setModalVisible(false);
      navigate('/BuyTopupHistory');
    } else {
      alert("Failed to update status.");
    }
  } catch (error) {
    console.error("Error updating status:", error);
    alert("Error occurred while updating status.");
  } finally {
    setModalLoading(false);
  }
};

  return (
    <div className="p-6 bg-white overflow-x-auto relative">
      <div className="flex justify-between items-center mb-4">
        <h1 className="text-5xl font-bold text-center flex-grow">
          {showRenewData ? "Renew Data Table" : "Top-Up Plans"}
        </h1>
        <button
          onClick={handleToggleView}
          className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded shadow"
        >
          {showRenewData ? "Show Top-Up History" : "Show Renew Data"}
        </button>
      </div>

      {loading ? (
        <LoadingSpinner />
      ) : showRenewData ? (
        // Renew Data Table
        <div className="overflow-x-auto">
          <table className="min-w-full bg-white border border-gray-200 text-sm">
            <thead>
              <tr className="border-b hover:bg-gray-100 text-left">
                <th className="text-center p-2 border">S.No</th>
                <th className="text-center p-2 border">Order ID</th>
                <th className="text-center p-2 border">Partner Code</th>
                <th className="text-center p-2 border">ICCID</th>
                <th className="text-center p-2 border">Plan Name</th>
                <th className="text-center p-2 border">Renewal Days</th>
                <th className="text-center p-2 border">Buy Amount</th>
                <th className="text-center p-2 border">User Amount</th>
                <th className="text-center p-2 border">New Expiry</th>
                <th className="text-center p-2 border">Created Date</th>
                <th className="text-center p-2 border">Status</th>
              </tr>
            </thead>
            <tbody>
              {renewData.length > 0 ? (
                renewData.map((item,index) => (
                  <tr key={item.id} className="border-b hover:bg-gray-100">
                     <td className="text-center p-2 border">{index+1}</td>
                    <td className="text-center p-2 border">{item.orderID}</td>
                    <td className="text-center p-2 border">{item.partnerCode}</td>
                    <td className="text-center p-2 border">{item.iccid}</td>
                    <td className="text-center p-2 border">{item.planName}</td>
                    <td className="text-center p-2 border">{item.renewalDays} Days</td>
                    <td className="text-center p-2 border">${parseFloat(item.buyAmount).toFixed(2)}</td>
                    <td className="text-center p-2 border">${parseFloat(item.userAmount).toFixed(2)}</td>
                    <td className="text-center p-2 border">
                      {new Date(item.newExpiryDate).toLocaleDateString()}
                    </td>
                    <td className="text-center p-2 border">
                      {new Date(item.createdDate).toLocaleDateString()}
                    </td>
                 <td className="text-center p-2 border">
                <button
                  onClick={() => {
                    setSelectedOrder({
                      orderID: item.orderID,
                      status: item.status === "Recharge" ? "InActive" : "Recharge",
                    });
                    setModalVisible(true);
                  }}
                  disabled={localStorage.getItem("role") === "Partner"}
                  className={`px-4 py-1 rounded text-white transition ${
                    item.status === "InActive" ? "bg-red-500" : "bg-green-400"
                  } ${
                    localStorage.getItem("role") === "Partner" ? "opacity-50 cursor-not-allowed" : ""
                  }`}
                >
                  {item.status === "InActive" ? "Pending" : "Renewed"}
                </button>
              </td>

                  </tr>
                ))
              ) : (
                <tr>
                  <td className=" p-2 border text-center" colSpan="10">
                    No renew data available.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      ) : (
        // Top-Up Plans Table
        <table className="w-full bg-white border rounded-lg shadow text-sm">
          <thead>
              <tr className="border-b hover:bg-gray-100 text-left">
              <th className="text-center p-3 px-5">Plan Name</th>
              <th className="text-center p-3 px-5">Created Date</th>
              <th className="text-center p-3 px-5">Price</th>
              <th className="text-center p-3 px-5">Email</th>
              <th className="text-center p-3 px-5">ICCID</th>
            </tr>
          </thead>
          <tbody>
            {data.length === 0 ? (
              <tr>
                <td colSpan="5" className="text-center py-4 text-gray-500">
                  No top-up plans available.
                </td>
              </tr>
            ) : (
              data.map((item, index) => (
                <tr key={index} className="border-b-2 hover:bg-gray-100">
                  <td className="text-center p-3 px-5">{item.planname}</td>
                  <td className="text-center p-3 px-5">{item.createddate}</td>
                  <td className="text-center p-3 px-5">${item.price}.00</td>
                  <td className="text-center p-3 px-5">{item.email}</td>
                  <td className="text-center p-3 px-5">{item.iccid.trim()}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      )}


      {modalVisible && selectedOrder && (
  <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
    <div className="bg-white rounded-lg shadow-lg p-6 w-96 relative">
      <h2 className="text-lg font-semibold mb-4">Update Renewal Status</h2>
      <p className="mb-2">Order ID: <strong>{selectedOrder.orderID}</strong></p>
      <div className="flex justify-between mt-6">
        <button
          onClick={handleStatusUpdate}
          disabled={modalLoading}
          className={`px-4 py-2 rounded text-white ${
            selectedOrder.status === "Renewed" ? "bg-green-400" : "bg-blue-500"
          }`}
        >
          {modalLoading ? "Updating..." : selectedOrder.status === "Renewed" ? "Mark as Pending" : "Mark as Renewed"}
        </button>
        <button
          onClick={() => setModalVisible(false)}
          className="px-4 py-2 rounded bg-gray-300 hover:bg-gray-400 text-black"
        >
          Cancel
        </button>
      </div>
    </div>
  </div>
)}

    </div>
  );
};

export default BuyTopupHistroy;






